import SelectTableIntraveneuzeGeneesmiddelenVoorDeBehandelingVanHypertensieveSpoedgevallen from "../../../../src/client/niv_acuteboekje/ui/SelectTableIntraveneuzeGeneesmiddelenVoorDeBehandelingVanHypertensieveSpoedgevallen";
import * as React from 'react';
export default {
  SelectTableIntraveneuzeGeneesmiddelenVoorDeBehandelingVanHypertensieveSpoedgevallen,
  React
};